export const MainItem = [
  {
    id: 1,
    intro: '고객과 함께하는 신뢰 있는 기업',
    main: 'WithUS Security',
    detail:
      '위더스 시큐리티는 고객의 안전한 업무 환경 조성을 위한 비즈니스 파트너로\n' +
      '가트너에서 선정한 이메일 보안 대표 기업 (주)기원테크의 이메일 솔루션 총판사입니다.',
    link: '/about-us',
    button: '자세히 보기',
  },
  {
    id: 2,
    intro: 'All-in-One 이메일 통합 보안',
    main: 'EG-Platform',
    detail:
      '발전되는 이메일 공격에 대응하기 위해서는 영역별 보안만으로는 부족합니다.\n' +
      'EG-Platform은 세계 유일, "이메일 보호"라는 목적 아래 전 영역에 일관된 보안을 제공합니다.',
    link: '/product/EG-Platform',
    button: '서비스 상세 보기',
  },
  {
    id: 3,
    intro: '자율형 AI 엔드포인트 보안 솔루션',
    main: 'SentinelOne',
    detail:
      '위협 라이프사이클의 모든 단계에서 각종 공격으로부터 모든 엔드포인트를\n' +
      '방어하는 글로벌 엔드포인트 보안의 리더, 자율형 AI 엔드포인트 보안 소프트웨어',
    link: '/product/SentinelONE',
    button: '서비스 상세 보기',
  },
  {
    id: 4,
    intro: '정보자산 보호 2차 인증 솔루션',
    main: 'BaroPAM',
    detail:
      'ID/PW를 이용한 로그인 방식에 동적 키(OTP)를 추가적으로 이용한 2차 인증으로\n' +
      '단순하면서도 강력하게 정보사잔을 보호하는 인증 솔루션입니다.',
    link: '/product/BaroPAM',
    button: '서비스 상세 보기',
  },
];

export const logoImg = [
  {
    id: 1,
    src: '/images/logo/logo01_lg.png',
  },
  {
    id: 2,
    src: '/images/logo/logo02_kolon.png',
  },
  {
    id: 3,
    src: '/images/logo/logo03_boryung.PNG',
  },
  {
    id: 4,
    src: '/images/logo/logo04_aju.PNG',
  },
  {
    id: 5,
    src: '/images/logo/logo05_hwaseung.png',
  },
  {
    id: 6,
    src: '/images/logo/logo06_samgong.png',
  },
  {
    id: 7,
    src: '/images/logo/logo07_hyundai.png',
  },
  {
    id: 8,
    src: '/images/logo/logo08_hyundai.gif',
  },
  {
    id: 9,
    src: '/images/logo/logo09_hyundai.png',
  },
  {
    id: 10,
    src: '/images/logo/logo10_hyundai.png',
  },
  {
    id: 11,
    src: '/images/logo/logo11_hyundai.png',
  },
  {
    id: 12,
    src: '/images/logo/logo12_hyundai.png',
  },
  {
    id: 13,
    src: '/images/logo/logo13_hyundai.png',
  },
  {
    id: 14,
    src: '/images/logo/logo14_din.png',
  },
  {
    id: 15,
    src: '/images/logo/logo15_nfri.png',
  },
  {
    id: 16,
    src: '/images/logo/logo16_cosmo-oil.png',
  },
  {
    id: 17,
    src: '/images/logo/logo17_utp.png',
  },
  {
    id: 18,
    src: '/images/logo/logo18_keri.png',
  },
  {
    id: 19,
    src: '/images/logo/logo19_dognwondtech.png',
  },
  {
    id: 20,
    src: '/images/logo/logo20_krict.png',
  },
  {
    id: 21,
    src: '/images/logo/logo21_kwdi.png',
  },
  {
    id: 22,
    src: '/images/logo/logo22_KEP.png',
  },
  {
    id: 23,
    src: '/images/logo/logo23_gshinsung.png',
  },
  {
    id: 24,
    src: '/images/logo/logo24_kma.png',
  },
];
